var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-ticket--attributes" }, [
    _c("section", { attrs: { "data-ticket-times": "" } }, [
      _c(
        "div",
        { staticClass: "md-form", attrs: { id: "open_time_id-form" } },
        [
          _c("i", {
            staticClass: "fa fa-clock-o prefix",
            class: { active: _vm.open_time_model != "" }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.open_time_model,
                expression: "open_time_model"
              }
            ],
            staticClass: "form-control timepicker",
            attrs: { type: "text", id: _vm.open_time.id },
            domProps: { value: _vm.open_time_model },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.open_time_model = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              class: { active: _vm.open_time_model != "" },
              attrs: { for: _vm.open_time.id }
            },
            [_vm._v("open time")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "md-form" }, [
        _c("i", {
          staticClass: "fa fa-clock-o prefix",
          class: { active: _vm.close_time_model != "" }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.close_time_model,
              expression: "close_time_model"
            }
          ],
          staticClass: "form-control timepicker",
          attrs: { type: "text", id: _vm.close_time.id },
          domProps: { value: _vm.close_time_model },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.close_time_model = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            class: { active: _vm.close_time_model != "" },
            attrs: { for: _vm.close_time.id }
          },
          [_vm._v("close time")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "container-fluid",
        attrs: { "data-event-ticket-attrubutes--spaces": "" }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "pseudo-form md-form" }, [
              _c("div", { staticClass: "pseudo-form--input border-0" }, [
                _c("div", { staticClass: "switch" }, [
                  _c("label", [
                    _vm._v(
                      "\n                                Off\n                                "
                    ),
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked:
                          _vm.isTicketEventAttributeActive(
                            "seats",
                            "not grouped by entity / seats switches"
                          ) === true
                            ? "checked"
                            : null
                      },
                      on: {
                        change: function($event) {
                          _vm.toggleTicketEventAttribute("seats")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "lever" }),
                    _vm._v(
                      "\n                                On\n                            "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 form-inline" }, [
            _c("div", { staticClass: "md-form mb-0 mb-md-4" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  id: "spaces-title-" + _vm.current_ticket.id,
                  disabled:
                    _vm.isTicketEventAttributeActive(
                      "seats",
                      "not grouped by entity / seats input"
                    ) !== true,
                  type: "text"
                },
                domProps: { value: _vm.readAttributeTitle("seats") }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "active",
                  attrs: { for: "spaces-title-" + _vm.current_ticket.id }
                },
                [
                  _vm._v(
                    "\n                        Spaces title\n                    "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.isTicketEventAttributeActive(
              "seats",
              "not grouped by entity / seats default"
            )
              ? _c("div", [
                  _c("div", { staticClass: "form-group ml-0 ml-md-3" }, [
                    _c("input", {
                      staticClass: "filled-in",
                      attrs: {
                        type: "checkbox",
                        id: "spaces-checked-" + _vm.current_ticket.id
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: {
                          for: "spaces-checked-" + _vm.current_ticket.id
                        }
                      },
                      [
                        _vm._v(
                          "Save\n                            title as default"
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "section",
      { attrs: { "data-event-ticket-attrubutes--slots": "" } },
      [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "pseudo-form md-form" }, [
                _c("div", { staticClass: "pseudo-form--input border-0" }, [
                  _c("div", { staticClass: "switch" }, [
                    _c("label", [
                      _vm._v(
                        "\n                                    Off\n                                    "
                      ),
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked:
                            _vm.isTicketEventAttributeActive(
                              "slots",
                              "not grouped by entity / time slot switches"
                            ) === true
                              ? "checked"
                              : null
                        },
                        on: {
                          change: function($event) {
                            _vm.toggleTicketEventAttribute("slots")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lever" }),
                      _vm._v(
                        "\n                                    On\n                                "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(1)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 form-inline" }, [
              _c("div", { staticClass: "md-form mb-0 mb-md-4" }, [
                _c("input", {
                  staticClass: "form-control",
                  attrs: {
                    disabled:
                      _vm.isTicketEventAttributeActive(
                        "slots",
                        "not grouped by entity / slots inputs"
                      ) !== true,
                    type: "text",
                    id: "slot-title-" + _vm.current_ticket.id,
                    required: ""
                  },
                  domProps: { value: _vm.readAttributeTitle("slots") }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "active",
                    attrs: { for: "slot-title-" + _vm.current_ticket.id }
                  },
                  [
                    _vm._v(
                      "Time\n                            slot\n                            title"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.isTicketEventAttributeActive(
                "slots",
                "not grouped by entity / slots inputs"
              )
                ? _c("div", { staticClass: "form-group ml-0 ml-md-3" }, [
                    _c("input", {
                      staticClass: "filled-in",
                      attrs: {
                        type: "checkbox",
                        id: "slot-checked-" + _vm.current_ticket.id,
                        checked: "checked"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "slot-checked-" + _vm.current_ticket.id }
                      },
                      [
                        _vm._v(
                          "Save\n                            title as default"
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "accordionShowDown" } }, [
          _vm.isTicketEventAttributeActive(
            "slots",
            "not grouped by entity / slots list"
          )
            ? _c(
                "div",
                {
                  staticClass: "pl-4 pr-4 p-2 mdb-color lighten-5",
                  attrs: { "data-show--slots": "true" }
                },
                [
                  _c("div", { key: _vm.index, staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-md-6 col-lg-4" }, [
                      _c("div", { staticClass: "pseudo-form md-form" }, [
                        _c(
                          "div",
                          {
                            staticClass: "pseudo-form--input",
                            class: {
                              "pseudo-form--input-focus":
                                _vm.time_slot_focused === true
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-start"
                              },
                              [
                                _c("div", { staticClass: "text-center pr-2" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.add_time_slot.start,
                                        expression: "add_time_slot.start"
                                      }
                                    ],
                                    ref: _vm.add_time_slot_ref,
                                    staticClass: "border-0 no-spinner",
                                    attrs: { type: "time" },
                                    domProps: {
                                      value: _vm.add_time_slot.start
                                    },
                                    on: {
                                      focus: function($event) {
                                        _vm.toggleTimeSlotFocus(true)
                                      },
                                      blur: function($event) {
                                        _vm.toggleTimeSlotFocus(false)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.add_time_slot,
                                          "start",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-center pl-2 pr-2" },
                                  [
                                    _vm._v(
                                      "\n                                        -\n                                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-center pl-2 pr-3" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.add_time_slot.end,
                                          expression: "add_time_slot.end"
                                        }
                                      ],
                                      staticClass: "border-0 no-spinner",
                                      attrs: { type: "time" },
                                      domProps: {
                                        value: _vm.add_time_slot.end
                                      },
                                      on: {
                                        focus: function($event) {
                                          _vm.toggleTimeSlotFocus(true)
                                        },
                                        blur: function($event) {
                                          _vm.toggleTimeSlotFocus(false)
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.add_time_slot,
                                            "end",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("transition", { attrs: { name: "fade" } }, [
                                  _vm.timeSlotActive()
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-outline-danger m-0",
                                              on: {
                                                click: function($event) {
                                                  _vm.createTimeSlot()
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-check"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pseudo-form--label active" },
                          [
                            _c("i", { staticClass: "fa fa-clock-o" }),
                            _vm._v(
                              " New time slot\n                            "
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.readTimeSlots(), function(time_slot, index) {
                      return _c(
                        "div",
                        { staticClass: "col-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center  justify-content-between watch-transition highlight-transition",
                              class: [
                                {
                                  "highlight-transition--danger":
                                    time_slot.hasOwnProperty("error") &&
                                    time_slot.error === true,
                                  "highlight-transition--success":
                                    time_slot.hasOwnProperty("success") &&
                                    time_slot.success === true
                                }
                              ]
                            },
                            [
                              _c("div", { staticClass: "text-center pr-2" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: time_slot.start,
                                      expression: "time_slot.start"
                                    }
                                  ],
                                  staticClass: "border-0",
                                  attrs: { type: "time" },
                                  domProps: { value: time_slot.start },
                                  on: {
                                    blur: function($event) {
                                      _vm.updateTimeSlot(
                                        _vm.ticketEventAttributeIndex("slots")
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        time_slot,
                                        "start",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-center pl-2 pr-2" },
                                [
                                  _vm._v(
                                    "\n                                -\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-center pl-2 pr-3" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: time_slot.end,
                                        expression: "time_slot.end"
                                      }
                                    ],
                                    staticClass: "border-0",
                                    attrs: { type: "time" },
                                    domProps: { value: time_slot.end },
                                    on: {
                                      blur: function($event) {
                                        _vm.updateTimeSlot(
                                          _vm.ticketEventAttributeIndex("slots")
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          time_slot,
                                          "end",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-center" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-danger m-0",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        _vm.deleteTimeSlot(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-trash" })]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    })
                  )
                ]
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pseudo-form--label active" }, [
      _c("i", { staticClass: "fa fa-cubes align-0" }),
      _vm._v(" Spaces\n                    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pseudo-form--label active" }, [
      _c("i", { staticClass: "fa fa-clock-o align-0" }),
      _vm._v(" Time Slots\n                        ")
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72c28dd2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72c28dd2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/ticketing/EventTicketAttributes.vue
// module id = 375
// module chunks = 0